/**
 * 充值记录 — 同 GET /api/admin/recharge，不按状态过滤（可在表格上筛选）。
 */
import { RechargeReviewPage } from './RechargeReviewPage';

export function RechargeLogPage() {
  return <RechargeReviewPage defaultStatusFilter={undefined} title="充值记录" />;
}
